import { render, staticRenderFns } from "./PartSelection.vue?vue&type=template&id=3b868a14&scoped=true"
import script from "./PartSelection.vue?vue&type=script&lang=js"
export * from "./PartSelection.vue?vue&type=script&lang=js"
import style0 from "./PartSelection.vue?vue&type=style&index=0&id=3b868a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b868a14",
  null
  
)

export default component.exports